import React from 'react';
import { Link } from 'react-router-dom';

import './HeaderTitle.css';

const HeaderTitle = () => {
  return (
    <Link to="/" className="HeaderTitle">
      MCLB-VJMO
    </Link>
  );
};

export default HeaderTitle;
